import { useCallback } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';
import { PostgresIntegration } from 'libs/end-to-end/src/types/databases/integrations/postgres-integration';
import { PostgresIntegrationTable } from 'libs/end-to-end/src/types/databases/integrations/postgres-integration';
import { POSTGRES_INTEGRATION_DEFAULT_RETRY_COUNT } from 'libs/end-to-end/src/types/databases/data-sets/postgres-integration-defaults';
import { Setter } from 'libs/end-to-end/src/ui-types';
import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';

export interface DataSetEditPostgresIntegrationHook {
  postgresIntegration: PostgresIntegration;
  setPostgresIntegration: Setter<PostgresIntegration>;
}

export const useDataSetEditPostgresIntegration =
  (): DataSetEditPostgresIntegrationHook => {
    const [tableList, setTableList] = useState<PostgresIntegrationTable[]>([]);
    const [retryCount, setRetryCount] = useState<number>(
      POSTGRES_INTEGRATION_DEFAULT_RETRY_COUNT,
    );
    const [pgDatabase, setPgDatabase] = useState<string>('');
    const [host, setHost] = useState<string>('');
    const [port, setPort] = useState<number>(5432);
    const [username, setUsername] = useState<string>('');
    const [ssl, setSsl] = useState<boolean>(false);

    const [passwordSecretReference, setPasswordSecretReference] =
      useState<SecretReference | null>(null);

    const setPostgresIntegration = useCallback(
      (postgresIntegration: PostgresIntegration) => {
        setTableList(postgresIntegration.tables);
        setRetryCount(postgresIntegration.retryCount);
        setPgDatabase(postgresIntegration.database);
        setHost(postgresIntegration.host);
        setPort(postgresIntegration.port);
        setUsername(postgresIntegration.user);
        setSsl(postgresIntegration.ssl);
        setPasswordSecretReference(
          postgresIntegration.passwordReference ?? null,
        );
      },
      [],
    );

    return useMemo(() => {
      return {
        postgresIntegration: {
          integrationType: 'Postgres',
          passwordReference: passwordSecretReference ?? undefined,
          database: pgDatabase,
          ssl,
          host,
          port,
          retryCount,
          tables: tableList,
          user: username,
        },
        setPostgresIntegration,
      };
    }, [
      host,
      passwordSecretReference,
      pgDatabase,
      port,
      retryCount,
      setPostgresIntegration,
      ssl,
      tableList,
      username,
    ]);
  };
